import { PopperItem } from './types';

export const popperItems: PopperItem[] = [
  {
    icon: '✍️',
    label: 'Transcript',
  },
  {
    icon: '🔑',
    label: 'Keywords',
  },
  {
    icon: '🎨',
    label: 'Episode art',
  },
  {
    icon: '📣',
    label: 'Social captions',
  },
  {
    icon: '💬',
    label: 'Show notes',
  },
  {
    icon: '🗣️',
    label: 'Quotes + references',
  },
];
